export const DEFAULT_LOCATION = 'the-city';

export const CONTACT_PHONE = '0203 011 4840';
export const CONTACT_EMAIL = 'hello@clays.bar';
export const GROUP_CONTACT_EMAIL = 'events@clays.bar';

export const FORGOT_PASSWORD = 'forgot-password';
export const SIGN_IN = 'sign-in';

export const SEVENROOMS_BASE_URL = 'https://www.sevenrooms.com/reservations';
export const SEVENROOMS_ALL_LOCATIONS_ID = 'clayslondon';

export const TOGGLE_URL =
  'https://giftcards.clays.bar/shop/clays-fully-loaded-gift-card';

export const AWS_S3_BUCKET_URL =
  'https://clays-booking-site-media.s3.eu-west-2.amazonaws.com';

// Scroll to hash IDs
export const PRICING_HASH_ID = 'pricing';
export const WHATS_ON_HASH_ID = 'scroll-to-whats-on';
export const LOCATION_HASH_ID = 'location';

export const WEBSITE_URL =
  process.env.NEXT_PUBLIC_WEBSITE_URL ||
  `https://${process.env.NEXT_PUBLIC_VERCEL_URL}` ||
  'https://clays.bar';

export const BOOKING_API_BASE_URL = process.env.SEVENROOMS_BOOKING_API_BASE_URL;

export const SEASON_MAPPING = {
  may: {
    label: 'May',
    value: '098ee71c-af43-4ef6-976f-ff86d20d6aaa',
  },
  jun: {
    label: 'June',
    value: '38a6c93c-a10c-4bd2-8d26-16b31f6936f6',
  },
  jul: {
    label: 'July',
    value: '7b2c182f-9611-4bdd-b58f-4bc69d71316a',
  },
  aug: {
    label: 'August',
    value: 'cf2c6e42-dc2e-4d1e-8fa8-5e4e0fe49c5f',
  },
  sep: {
    label: 'September',
    value: 'a8571d19-ba35-4841-a282-60f1e9624dac',
  },
  oct: {
    label: 'October',
    value: 'be6b61a3-bb60-4258-9eb7-81d4fc11c670',
  },
};
